import React from 'react';
import { Button, Tooltip, Grid } from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CancelPresentation as CancelPresentationIcon,
  LocalPrintshop as PrintIcon,
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  NavigateNext as NavigateNextIcon
} from '@mui/icons-material';
import { usePermissions } from '../GlobalFunction/userPermissions';

const CrudButtons = ({ 
  moduleName, 
  mode, 
  onAdd, 
  onEdit, 
  onView, 
  onDelete, 
  onExit, 
  onPrevious,
  onNext,
  readOnlyMode,
  hideAdd = false,
  hideEdit = false,
  hideDelete = false,
  hideView = false,
  hideExit = false,
  disableExit = false,
  disablePrint = false,
  hidePreviousNext = false
}) => {
  const permissions = usePermissions(moduleName);
 
  const buttonSx = {
    backgroundColor: '#635bff',
    margin: { xs: '0px 5px', sm: '0px 5px' },
    minWidth: { xs: '40px', sm: '40px', md: '60px' },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)",
      boxShadow: "none",
    }
  };

  const getTooltipMessage = (action, permission) => {
    const actionMessages = {
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      view: "Print",
      exit: "Exit"
    };
    
    if (permission === "0") {
      return "You don't have permission for this action";
    }
    
    return actionMessages[action] || "";
  };

  return (
    <Grid
      sx={{
        display: 'flex',
        justifyContent: { xs: 'center', sm: 'center' },
        margin: { xs: '10px 0px 0px 0px', sm: 0 }
      }}
    >
    

      {!hideAdd && (
        <Tooltip title={getTooltipMessage("add", permissions.AddRec)}>
          <span>
            <Button
              variant="contained"
              size="small"
              sx={buttonSx}
              onClick={onAdd}
              disabled={!readOnlyMode || permissions.AddRec === "0"}
            >
              <AddIcon />
            </Button>
          </span>
        </Tooltip>
      )}

      {!hideEdit && (
        <Tooltip title={getTooltipMessage("edit", permissions.EditRec)}>
          <span>
            <Button
              variant="contained"
              size="small"
              sx={buttonSx}
              onClick={onEdit}
              disabled={!readOnlyMode || permissions.EditRec === "0"}
            >
              <EditIcon />
            </Button>
          </span>
        </Tooltip>
      )}

      {!hideDelete && (
        <Tooltip title={getTooltipMessage("delete", permissions.DeleteRec)}>
          <span>
            <Button
              variant="contained"
              size="small"
              sx={buttonSx}
              onClick={onDelete}
              disabled={!readOnlyMode || permissions.DeleteRec === "0"}
            >
              <DeleteIcon />
            </Button>
          </span>
        </Tooltip>
      )}

      {!hideView && (
        <Tooltip title={getTooltipMessage("view", permissions.ViewRec)}>
          <span>
            <Button
              variant="contained"
              size="small"
              sx={buttonSx}
              onClick={onView}
              disabled={disablePrint || permissions.ViewRec === "0"}
            >
              <PrintIcon />
            </Button>
          </span>
        </Tooltip>
      )}

      {!hideExit && (
        <Tooltip title={getTooltipMessage("exit")}>
          <Button
            variant="contained"
            size="small"
            sx={buttonSx}
            onClick={onExit}
            disabled={disableExit}
          >
            <CancelPresentationIcon />
          </Button>
        </Tooltip>
      )}
    </Grid>
  );
};

export default CrudButtons;